<template>
  <div class="page-wrap">
    <Button
      type="primary"
      round
      size="mini"
      :disabled="modelValue === 1"
      @click="updatePage(modelValue - 1)"
    >
      上一页
    </Button>
    <div class="page-content">
      <span class="page__current">{{ modelValue }}</span>
      <span class="wd-pager__separator">/</span>
      <span>{{ computedPageSize }}</span>
    </div>
    <Button
      type="primary"
      size="mini"
      round
      :disabled="modelValue === computedPageSize"
      @click="updatePage(modelValue + 1)"
    >
      下一页
    </Button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'
import { Button } from 'vant'

const props = defineProps({
  total: {
    type: Number,
    default: 0
  },
  pageSize: {
    type: Number,
    default: 5
  },
  modelValue: {
    type: Number,
    default: 1
  }
})
const emit = defineEmits(['update:modelValue', 'change'])

const computedPageSize = computed(() => {
  return Math.ceil(props.total / props.pageSize) || 1
})

const updatePage = page => {
  if (page >= 1 && page <= computedPageSize.value) {
    emit('update:modelValue', page)
    emit('change', page)
  }
}
</script>

<style lang="less" scoped>
.page-wrap {
  // background-color: #fff;
  padding: 16px;
  display: flex;
  align-items: center;

  .page-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }
}
</style>
